// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `v-workflow .input-short {
  width: 80px !important;
}
v-workflow .workflow {
  align-items: flex-start;
}
v-workflow .workflow .inheritance {
  width: 270px;
  background: var(--gc-color-light);
  border: 1px solid var(--gc-border-color);
  padding: 0.5rem;
}
v-workflow .workflow .settings {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/components/workflow/workflow.component.sass"],"names":[],"mappings":"AACI;EACI,sBAAA;AAAR;AACI;EACI,uBAAA;AACR;AAAQ;EACI,YAAA;EACA,iCAAA;EACA,wCAAA;EACA,eAAA;AAEZ;AADQ;EACI,YAAA;AAGZ","sourcesContent":["v-workflow\n    .input-short\n        width: 80px !important\n    .workflow\n        align-items: flex-start\n        .inheritance\n            width: 270px\n            background: var(--gc-color-light)\n            border: 1px solid var(--gc-border-color)\n            padding: 0.5rem\n        .settings\n            flex-grow: 1"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
